import { AudioConfig } from "./media_audio-config.js";
import { Player } from "./media_player.js";
import { PluginGa4 } from "./media_plugin-ga4.js";
import { PluginNpaw } from "./media_plugin-npaw.js";
import { PluginPosition } from "./media_plugin-position";

export class AudioPlayer extends Player {
  protected readonly config: AudioConfig;

  public constructor(element: HTMLElement) {
    super(element);
    this.config = new AudioConfig(this.media);
  }

  protected registerPlugins(): void {
    this.plugins.add(new PluginGa4(this.media, "audio"));
    this.plugins.add(new PluginNpaw(this.media));
    this.plugins.add(new PluginPosition(this.media));
  }
}
